import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { IwgSelectService } from "../../shared/services/iwgselect.service";
import { IwgSelect } from "../../shared/models/iwgselect.model";
import { UserService } from "src/app/shared/services/user.service";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FormBuilder, NgForm } from "@angular/forms";
import { AssignmentService } from "src/app/shared/services/assignment.service";
import { DownloadService } from "src/app/shared/services/download.service";
import { throwToolbarMixedModesError } from "@angular/material/toolbar";
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { DocumentsService } from "src/app/shared/services/documents.service";
import {IWGSharedService} from 'src/app/shared/services/shared.service';

@Component({
  selector: "app-assigmentdocument-dialog",
  templateUrl: "./assigmentdocument-dialog.component.html",
  styleUrls: ["./assigmentdocument-dialog.component.scss"],
})
export class AssigmentdocumentDialogComponent implements OnInit {
  name: any;
  @ViewChild("documentStep1") documentStep1: NgForm;
  WizardTitle = "Add a Document";
  selectedStepIndex = 0;
  numberOfSteps = 1;
  maxSteps = 1;
  isLoading = false;
  notes: any;

  evaluationDocumentTypeID: any;
  documentTypeID: any;
  documentTypeName: any;
  document_name: any;
  issued_date: any;
  docFileName: any;
  documentFileIDs = null;
  assignmentId: any;
  contractorName: any;
  bussinessName: any;
  documentFileList = [];
  step1 = {
    document_name:null,
    issued_date:null,
    expiration_date:null,
    notes:null
  };
  uploadedMultipleFiles = [];
  isFileUploadInProgress = false;
  currentDate = new Date();
  expiration_date: any;
  flag:boolean=true;
  existingDocument:any;
  props:any;
  statusId:any;
Hposition:MatSnackBarHorizontalPosition = "right";
VPosition:MatSnackBarVerticalPosition = "top";
isEmbed =false;
  constructor(
    private fb: FormBuilder,
    private sharedService: IWGSharedService,
    private dialogRef: MatDialogRef<AssigmentdocumentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private downloadService: DownloadService,
    public documentsService: DocumentsService,private toast:MatSnackBar,private router: Router,
  ) {
    this.name = data;
  }

  ngOnInit(): void {
    this.flag=true;
    this.documentTypeName = this.name.documentTypeName;
    this.assignmentId = this.name.AssignmentId;
    this.contractorName = this.name.ContractorName;
    this.bussinessName = this.name.BussinessName;
    this.documentTypeID = this.name.documentTypeID;
    this.existingDocument=this.name.existingDocument;   
    if(this.existingDocument) {
      this.populateForm(this.existingDocument);
    }
    this.isEmbed = this.sharedService.getIsEmbed();
  }
  saveDraft() {            
      const statusId = 1;
      return this.save(statusId);
  }
  saveAsDraft(): void{
    this.saveDraft().then((response:any)=>{
      //if (response.IsSuccessful) {
        if (response.data.ErrorCode == 200) {
          this.dialogRef.close();
          this.showConfirmationToast('Draft has been saved.');
      } else {
          this.showConfirmationToast('Error saving draft.');
      }
    })
    .catch(err=>{console.log(err)})
  }
  save(statusId) {
    this.isLoading = true;

    if (this.documentStep1.valid) {
      this.props = {
        new_status_id: statusId,
        assignment_id: this.assignmentId,
        document_type_id: this.documentTypeID,
        // assignment_id: "26912",
        // document_file_ids:"56139",
        document_type_name: this.documentTypeName,
        document_name: this.step1.document_name,
        issued_date: this.step1.issued_date
          ? this.step1.issued_date.toLocaleString()
          : this.step1.issued_date,
        expiration_date: this.step1.expiration_date
          ? this.step1.expiration_date.toLocaleString()
          : this.step1.expiration_date,
        document_file_ids: this.getFileIDs(),
        notes: this.step1.notes,
      };
    }
    if (this.evaluationDocumentTypeID) {
      return this.documentsService
        .update(this.evaluationDocumentTypeID, this.props).toPromise()
        .then(data=>{this.onSaveSuccess(data);return data;})
        .catch(err=>this.onSaveError(err));
    } else {
      return this.documentsService
        .save(this.props).toPromise()
        .then(data=>{this.onSaveSuccess(data);return data;})
        .catch(err=>this.onSaveError(err));
    }
  }
  getFileIDs() {
    var documentIds = null;
    var tempdocumentIds = [];
    this.documentFileList.forEach(function (file, key) {
      tempdocumentIds.push(file.DocumentID);
    });   
    if (tempdocumentIds.length > 0) {
      documentIds = tempdocumentIds.join(",");
    }
    return documentIds;
  }
  populateForm(existingDocument) {
    if (existingDocument) {
      this.evaluationDocumentTypeID = existingDocument.DocumentID;
      this.documentTypeID = existingDocument.DocumentTypeID;
      this.documentTypeName = existingDocument.DocumentTypeName;
      //$scope.documentFileIDs = existingDocument.documentFileIDs;
      this.step1 = {
        document_name: existingDocument.DocumentName,
        issued_date: existingDocument.DateIssued
          ? new Date(existingDocument.DateIssued)
          : null,
        expiration_date: existingDocument.DateExpired
          ? new Date(existingDocument.DateExpired)
          : null,
        notes: existingDocument.Notes,
      };
      if (existingDocument.DocumentList) {
        this.documentFileList = existingDocument.DocumentList;
        existingDocument.DocumentList.forEach(function (fileDetail, key) {
          this.uploadedMultipleFiles.push({
            Name: fileDetail.Name,
            isValidFile: true,
          });
        });
      }
      // $scope.Ready = true;
    }
  }
  canProceed() {
    let step = this.selectedStepIndex + 1;

    let valid = false;
    if (this["documentStep" + step]) {
      valid = this["documentStep" + step].valid;
    }
    if (this.documentFileList.length <= 0) {
      // If more than one step comes in Wizard, need to validate only for step1.
      valid = false;
    }

    return valid;
  }

  prevStep() {
    this.resetFileErrorMessages();
    this.selectedStepIndex -= 1;
  }

  // Load documents info when editing an document or when adding an document to a specific assignment
 
  resetFileErrorMessages() {
    //Reset the error messages.
    // $rootScope.$emit('iwg.file.attached.reset');
  }

  cancel() {
    this.dialogRef.close();
  }

  onSaveSuccess(response) {
    this.isLoading = false;
    this.evaluationDocumentTypeID = response.data.Data.DocumentID;
    if (response.ErrorCode!=200) {
      // console.error(error);
    }
  }

  onSaveError(error) {
    this.isLoading = false;
    console.error(error);
  }
  nextStep() {
    let canProceed = false;
    let stepIndex = this.selectedStepIndex + 1;

    switch (stepIndex) {
      case 1:
        // this.documentStep1.setSubmitted();
        canProceed = this.documentStep1.valid;
        if (this.documentFileList.length <= 0) {
          canProceed = false;
        }
        break;
      case -1:
        canProceed = true;
        break;
    }

    if (canProceed) {
      let index =
        this.selectedStepIndex == this.maxSteps
          ? 0
          : this.selectedStepIndex + 1;
      this.saveDraft().then(() => {
        this.selectedStepIndex = index;
      })
    }

    this.resetFileErrorMessages();
  }
//   saveAsDraft = () => {
//     this.save()
// };
public create(value){
  const self=this;
  value.forEach(function (files, key1) {
    if (files.IsSuccessful == true) {
      self.documentFileList.push(files.TheObject);
    }
});
}
submit = () => {
  // Submitted status
  const statusId = 2;
  return this.save(statusId).then((response) => {
      if (response.data.ErrorCode == 200) {
        this.dialogRef.close();       
          if (response.data.Data.AssignmentStatusID == 15) {
              //setTimeout(function () {    
               this.sharedService.assignmentStatusChange.next(true); 
               alert('Thank you for submitting all required documentation.'); 
               // }, 900); //To show the alert after pop-up closes using 900 mili secods timeout.
          } else {
              this.showConfirmationToast('Thank you! Document has been submitted.');
          }
      } else {
          this.showConfirmationToast('Error submitting form.');
          // console.error(error);
      }
  })
    };
showConfirmationToast(text){
  this.toast.open(text, "Got it", {
    duration: 2000,horizontalPosition:this.Hposition,
    verticalPosition:this.VPosition,
    panelClass: 'iwg-toast-text-white',
  });
}
downloadDocumentFile(document_file_id){
  this.downloadService.saveAs('/Api/File/' + document_file_id);
}
deleteDocumentFile = (document_file_id) => {
  this.documentFileList = this.documentFileList.filter(function (returnableObjects) {
      return returnableObjects.ID != document_file_id;
  });
  // $rootScope.$broadcast('iwg.file.uploadedMultipleFileNames', getUpdatedFileNames(document_file_id));
};
}
